import React from 'react'
import { useAppContext } from '../../../App';
import { Box,  Image, Text, useTheme } from '@chakra-ui/react';
import imgTrayectos from '../../../innerAsstes/imagenes hero y modulo curso/Asset 4gestar.png';
import ButtonMore from '../../../components/buttonMore/buttonMore';

export default function OtherCoursesStepCard({
    item = {name: ""},
    category,
    type
}) {
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile);
  const titleArray = item.name.split(' ');
  const title1 = titleArray.slice(0, 3)
  const title2 = titleArray.slice(3, titleArray.length)
  return (
    <Box as='div' style={style.container} className='sansation-bold'>
      <Image style={style.img} src={imgTrayectos} alt="Course" />
      <Box as='div' style={{marginLeft: '1rem'}}>
        <Text style={style.title1}>{title1.map(item => ` ${item}`)}</Text>
        <Text style={style.title2}>{title2.map(item => ` ${item}`)}</Text>
        <ButtonMore redirectTo={`/formulario-inscripcion/${type}/${category}/${item.id}`} buttonText='Saber más' customStyles={{
            container:{
                width: isMobile?'80%':'50%',
                padding: '2%'
            }
        }}/>
      </Box>
    </Box>
  );
}

const styles = (theme,isMobile) => ({
  container: {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    width: isMobile ? '90vw' : '25vw',      // Cambiado aquí
    minHeight: isMobile ? '180px' : 'auto', // Opcional: ajusta el alto mínimo
    margin: isMobile ? '0 auto 1rem auto' : '0 1rem 1rem 0', // Centrado en móvil
    background: '#fff', // Opcional: fondo blanco para destacar
    borderRadius: '12px', // Opcional: bordes redondeados
    boxShadow: isMobile ? '0 2px 8px rgba(0,0,0,0.07)' : 'none', // Opcional: sombra en móvil
    alignItems: 'center',
    justifyContent: 'center'
  },
  title1:{
    fontSize: isMobile?'1.5rem':'2rem',
    width: '90%',
    wrap: "wrap",
    whiteSpace: "wrap",
    lineHeight: 1,
    color: theme.color.text.secondary
  },
  title2:{
    fontSize: isMobile?'1.2rem':'1.5rem',
    wrap: "wrap",
    whiteSpace: "wrap",
    lineHeight: 1,
    color: theme.color.text.tertiary,
    marginBottom: '3%',
  },
  img: isMobile?
  {
    alignSelf: 'center',
    width: '60%'
  }:{}
});
